export default "__VITE_ASSET__wXnqusak__"